import { render, staticRenderFns } from "./PlantEdit.vue?vue&type=template&id=3aee4a02&scoped=true&"
import script from "./PlantEdit.vue?vue&type=script&lang=js&"
export * from "./PlantEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aee4a02",
  null
  
)

export default component.exports